import { queryOptions, useQuery } from '@tanstack/react-query';

import { makeIsEnabled } from '@cast/utils';

import { useCurrentOrganizationId } from '@cast/infrastructure-organization';
import { apiClient } from '@cast/infrastructure-api';

const IMPACT_REPORT_QUERY_KEY = 'impact-report';

const getImpactReportQueryKey = ({
  organizationId,
  clusterId,
  startTime,
  endTime,
}: {
  organizationId?: string;
  clusterId?: string;
  startTime?: string;
  endTime?: string;
}) =>
  [
    IMPACT_REPORT_QUERY_KEY,
    organizationId,
    clusterId,
    startTime,
    endTime,
  ] as const;

const getImpactReportQueryOptions = ({
  organizationId,
  clusterId,
  startTime,
  endTime,
  enabled,
}: {
  organizationId: string;
  clusterId?: string;
  startTime?: string;
  endTime?: string;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: getImpactReportQueryKey({
      organizationId,
      clusterId,
      startTime,
      endTime,
    }),
    queryFn: async () => {
      const { data } = await apiClient.stop.getImpactReport({
        organizationId,
        clusterId: clusterId!,
        startTime,
        endTime,
      });
      return data;
    },
    enabled: makeIsEnabled(!!clusterId, enabled),
  });

export const useImpactReportQuery = ({
  clusterId,
  startTime,
  endTime,
  enabled,
}: {
  clusterId?: string;
  startTime?: string;
  endTime?: string;
  enabled?: boolean;
} = {}) => {
  const organizationId = useCurrentOrganizationId();

  return useQuery(
    getImpactReportQueryOptions({
      organizationId,
      clusterId,
      startTime,
      endTime,
      enabled,
    })
  );
};
